import { Component, EventEmitter, OnInit, Output, Input, SimpleChanges, OnChanges } from '@angular/core';
import { DataService, HelperService } from 'app/services';
import { HTTPService } from 'app/services/http.service';

@Component({
  selector: 'app-shop-location-dropdown',
  templateUrl: './shop-location-dropdown.component.html',
  styleUrls: ['./shop-location-dropdown.component.scss'],
})
export class ShopLocationDropdownComponent implements OnInit, OnChanges {
  @Input() preSelectedLocationsIds: any[] = [];
  @Output() preSelectedLocationsIdsChange = new EventEmitter<any[]>();
  @Output() filterChange = new EventEmitter<any>();

  filterApplied = {
    location: false,
  };
  filter: any = {
    location: {
      selected: [],
    },
  };
  filterTitle = {
    location: {
      all: 'All',
      multiple: 'Multiple Location',
    },
  };
  closeAfterAction: boolean = false;
  companyLocations: any[] = [];
  currentShopId: string = '';
  shopColor: any = {};

  constructor(
    private helperService: HelperService,
    private httpService: HTTPService,
    public dataService: DataService,
  ) {}

  async ngOnInit() {
    this.getCompanyLocation();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.preSelectedLocationsIds) {
      this.filter.location.selected = this.companyLocations.filter((shop) => this.preSelectedLocationsIds.includes(shop._id));

      this.companyLocations.forEach((shop) => {
        shop.isChecked = this.preSelectedLocationsIds.includes(shop._id);
      });
    }
  }
  getCompanyLocation() {
    const { employeeId } = this.helperService.getCompany();

    this.httpService.getShopLists({ employeeId }).then(
      (data) => {
        this.currentShopId = data.employee && data.employee.currentShopId;
        this.companyLocations = data.records || [];
        this.getDefaultLocationSelected();
        this.handleFilterChange();
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  clearFilter(type: string = '') {
    switch (type) {
      case 'location':
        this.filter.location = {
          selected: [],
        };
        this.companyLocations = this.companyLocations.map((companyLocations) => ({
          ...companyLocations,
          isChecked: false,
        }));
        this.dataService.sendData(this.dataService.typePassData('clearSelectAllFilter', true));
        break;
    }
    this.filterApplied[type] = false;
    // this.getDefaultLocationSelected();
    this.filterChange.emit(this.filter?.location?.selected || []);
  }

  whichFilterApplied(type: string = '') {
    const { location = {} } = this.filter;

    switch (type) {
      case 'location':
        this.filterApplied.location = !!(location && location.selected && location.selected.length);
        break;
    }
  }

  changeTagFilter(key: string, event: any, isMultiple: boolean = false) {
    if (isMultiple) {
      this.filter[key].selected = this.helperService.deepCopy(event);
    } else {
      this.filter[key] = event;
    }

    this.whichFilterApplied(key);
    this.closeAfterAction = !this.closeAfterAction;
    this.handleFilterChange();
    this.emitChanges();
  }

  handleFilterChange() {
    const shops = this.companyLocations.filter(({ isChecked }) => isChecked);
    // if (shops.length === 0) {
    //   this.getDefaultLocationSelected();
    // }
    this.filterChange.emit(shops?.length ? shops : this.filter?.location?.selected);
  }

  getDefaultLocationSelected(clearFilter = false) {
    this.companyLocations.forEach((shop: any) => {
      if (shop._id === this.currentShopId) {
        if (this.preSelectedLocationsIds && !this.preSelectedLocationsIds.length) {
          this.filter.location = { selected: [shop] };
          shop.isChecked = true;
          this.filterApplied.location = true;
        }
        this.shopColor = shop.locationColor;
      }

      if (this.preSelectedLocationsIds && this.preSelectedLocationsIds.length && !clearFilter) {
        this.preSelectedLocationsIds.forEach((shopId: string) => {
          if (shop._id === shopId && !shop.isChecked) {
            this.filter.location.selected.push(shop);
            shop.isChecked = true;
            this.filterApplied.location = true;
          }
        });
      }
    });
  }

  emitChanges() {
    this.preSelectedLocationsIds = this.filter.location.selected.map(({ _id }) => _id);
    this.preSelectedLocationsIdsChange.emit(this.preSelectedLocationsIds);

    this.filterChange.emit(this.filter.location.selected);
  }
}
